import { render, staticRenderFns } from "./buyHold.vue?vue&type=template&id=1a927b21&scoped=true"
import script from "./buyHold.vue?vue&type=script&lang=js"
export * from "./buyHold.vue?vue&type=script&lang=js"
import style0 from "./buyHold.vue?vue&type=style&index=0&id=1a927b21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a927b21",
  null
  
)

export default component.exports